import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { CostEstimateRowsCalculator } from "../services/costEstimateRowsService";
import articlesCalc from "../services/articlesCalcService";

class Delivery extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.updateCalculatedRows();
    }

    updateCalculatedRows() {
        window.deliverySettings.calculatedRows = [];

        this.props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);
            const quantity = row.quantity;

            // const desiredQuantity = parseFloat(this.props.multiplier);
            let multiplier = parseFloat(this.props.multiplier);

            let recalculatedMultiplier = multiplier;
            let recalculatedQuantity = quantity * multiplier;

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    recalculatedMultiplier = Math.ceil(
                        multiplier / row.objectsPerRow
                    );

                    recalculatedQuantity = quantity * recalculatedMultiplier;
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    recalculatedMultiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;

                    const sheetSizeM2 = (row.width * row.height) / 1000000;
                    const maxObjectsPerSheet = row.objectsPerRow;
                    const sheetsNeeded = Math.ceil(
                        multiplier / maxObjectsPerSheet
                    );

                    recalculatedQuantity = sheetsNeeded * sheetSizeM2;
                }
            }

            const calculatedRow = {
                article_id: row.article_id,
                name: row.name,
                quantity: row.is_single ? 1 : recalculatedQuantity,
                price: calc
                    .getPrice(row.is_single ? 1 : recalculatedMultiplier)
                    .toFixed(2),

                discount_percent: calc
                    .getDiscount(row.is_single ? 1 : recalculatedMultiplier)
                    .toFixed(2),
                order_row_id: row.id,
                parent_order_row_id: null,
                infoboarddata: row.infoboarddata
            };

            window.deliverySettings.calculatedRows.push(calculatedRow);

            row.children.forEach(childRow => {
                const calc = new articlesCalc();
                calc.setData(childRow);
                let quantity = childRow.quantity;

                let multiplier = parseFloat(this.props.multiplier);

                if (childRow.objectsPerRow != undefined) {
                    multiplier = Math.ceil(multiplier / childRow.objectsPerRow);
                }

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                if (childRow.is_single) multiplier = 1;

                quantity *= multiplier;

                const calculatedRow = {
                    article_id: childRow.article_id,
                    name: childRow.name,
                    quantity: quantity,
                    price: calc.getPrice(multiplier).toFixed(2),
                    discount_percent: calc.getDiscount(multiplier).toFixed(2),
                    order_row_id: childRow.id,
                    parent_order_row_id: row.id,
                    infoboarddata: null
                };

                window.deliverySettings.calculatedRows.push(calculatedRow);
            });
        });

        window.dispatchEvent(new CustomEvent("delivery:articleRowsCalculated"));
    }

    render() {
        const { multiplier } = this.props;
        const rows = [...this.props.rows];

        const props = {
            multiplier,
            rows
        };

        return (
            <Fragment>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th key={1} className="text-right">
                                Antal
                            </th>
                            <th key={2} className="text-right">
                                Vikt i kg
                            </th>
                            <th key={3} className="text-right">
                                Pris/st
                            </th>
                            <th key={4} className="text-right">
                                Pris
                            </th>
                            {CostEstimateRowsCalculator.hasAnyDiscount(props) && (
                                <Fragment>
                                    <th key={5} className="text-right">
                                        Rabatt
                                    </th>
                                    <th key={6} className="text-right">
                                        Pris/st
                                    </th>
                                    <th key={7} className="text-right">
                                        Slutpris
                                    </th>
                                </Fragment>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        <tr key={0}>
                            <td key={1} className="text-right">
                                {multiplier}
                            </td>
                            <td key={2} className="text-right">
                                {CostEstimateRowsCalculator.getTotalWeight(
                                    props
                                )}
                            </td>
                            <td key={3} className="text-right">
                                {Number(
                                    CostEstimateRowsCalculator.getTotalUnitPrice(
                                        props
                                    )
                                ).toSek()}
                            </td>
                            <td key={4} className="text-right">
                                {Number(
                                    CostEstimateRowsCalculator.getTotalPrice(
                                        props
                                    )
                                ).toSek()}
                            </td>
                            {CostEstimateRowsCalculator.hasAnyDiscount(props) && (
                                <Fragment>
                                    <td key={5} className="text-right">
                                        {CostEstimateRowsCalculator.getTotalDiscount(
                                            props
                                        ) + "%"}
                                    </td>
                                    <td key={6} className="text-right">
                                        {Number(
                                            CostEstimateRowsCalculator.getTotalUnitPriceAfterDiscount(
                                                props
                                            )
                                        ).toSek()}
                                    </td>
                                    <td key={7} className="text-right">
                                        {Number(
                                            CostEstimateRowsCalculator.getTotalPriceAfterDiscount(
                                                props
                                            )
                                        ).toSek()}
                                    </td>
                                </Fragment>
                            )}
                        </tr>
                    </tbody>
                </table>
            </Fragment>
        );
    }
}

if (window.deliverySettings) {
    const t = window.deliverySettings;
    ReactDOM.render(
        <Delivery
            multiplier={t.data.multiplier}
            customer={t.data.customer}
            rows={t.data.rows}
        />,
        t.settings.target
    );
}
